import React from 'react'
import { UserData } from '../../actions/UserDataAction'
import { useDispatch } from 'react-redux';
import { ServerRequestProtected } from '../../utils/ServerDataRequest';
import { enumUtil } from '../../utils/Enum';
import NotificationHandler from '../../utils/NotificationHandler';

const useUserData = () => {
  const API_URL = enumUtil.controller.General;
  const dispatch = useDispatch();

  const handleLoadUserData = () => {
    // setisLoading(true)
    ServerRequestProtected(API_URL + "/UserData", 'post', {
      TableName: enumUtil.enumAPITableName.User
    }).then((response) => {
      dispatch(UserData(response))
    }).catch((error) => {
      NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
    })
  }
  return ({ handleLoadUserData })
}

export default useUserData